export const permission = [
  {
    modules: 'Sections',
    created: '',
    view: '',
    edit: '',
    delete: '',
    allowAll: '',
  },
];
